import { c as _c } from "react/compiler-runtime";
import React from 'react';
import usePDPProductLabel from 'data-hooks/usePDPProductLabel';
import PDPGalleryLabelsUI from './PDPGalleryLabelsUI';
const PDPGalleryLabels = () => {
  const $ = _c(5);
  const {
    loading,
    error,
    data: t0
  } = usePDPProductLabel();
  const {
    productLabel
  } = t0;
  if (error) {
    return null;
  }
  const t1 = loading && !productLabel;
  let t2;
  if ($[0] !== productLabel) {
    t2 = productLabel ? [productLabel] : [];
    $[0] = productLabel;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <PDPGalleryLabelsUI loading={t1} labels={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default PDPGalleryLabels;